import { createFileRoute, redirect } from '@tanstack/react-router'

// Alerts live with the follows now; this address stays for links already sent (alert emails).
export const Route = createFileRoute('/app/investor/$id/notifications')({
  beforeLoad: ({ params }) => {
    throw redirect({ to: '/app/investor/$id/follows', params })
  },
})
